import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../pages/Layout";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../pages/Login";
import Register from "../pages/Register";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import PagePolicy from "../pages/Policies";
import AuthStore from "../pages/AuthStore";
import AuthDrive from "../pages/AuthPages/AuthDrive";
import AccountActivatePage from "../pages/Account/activate";
import Gateways from "../pages/Gateways";
import StoresPage from "../pages/Stores";
import StoreDetailPage from "../pages/Stores/storeDetail";
import OrdersPage from "../pages/Orders";
import OrderDetailPage from "../pages/OrderDetail";

import SettingsPage from "../pages/Settings";
import NotFound from "../pages/NotFound";
import ProfilePage from "../pages/Profile";

// Import css
import "../assets/css/general.scss";
import Dashboard from "../pages/Dashboard";
import WorkspacePage from "../pages/Workspace";
import WorkspaceDetailPage from "../pages/Workspace/detail";
import MailTemplatesPage from "../pages/MailTemplates";
import SupplierStockPage from "../pages/SupplierStock";
import ToolSupportPage from "../pages/ToolSupport";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/reset-password/:token"
            element={<ResetPassword />}
          />
          <Route path="/policy" element={<PagePolicy />} />
          <Route path="/authStore" element={<AuthStore />} />
          <Route path="/auth/drive" element={<AuthDrive />} />
          <Route
            path="/account/activate"
            element={<AccountActivatePage />}
          />
          <Route
            path="/account/activate/:token"
            element={<AccountActivatePage />}
          />
          <Route
            path="/stores"
            element={
              <ProtectedRoute>
                <StoresPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stores/:id"
            element={
              <ProtectedRoute>
                <StoreDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <ProtectedRoute>
                <OrderDetailPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/workspace"
            element={
              <ProtectedRoute>
                <WorkspacePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/workspace/:workspaceId"
            element={
              <ProtectedRoute>
                <WorkspaceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mail-templates"
            element={
              <ProtectedRoute>
                <MailTemplatesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/supplier-stock"
            element={
              <ProtectedRoute>
                <SupplierStockPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tool-support"
            element={
              <ProtectedRoute>
                <ToolSupportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gateways"
            element={
              <ProtectedRoute>
                <Gateways />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />}></Route>
        </Route>
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
};

export default AppRouter;
